<div class="flex flex-col gap-2">
  @if (props.label) {
    <label [for]="id" class="font-semibold">
      {{ props.label }}
      @if (props.required) {
        <span class="text-red-500">*</span>
      }
    </label>
  }

  <app-month-picker
    [inputId]="id"
    [formControl]="dateControl"
    (focusout)="onBlur()"
    [displayFormat]="displayFormat"
    [placeholder]="props.placeholder || ''"
    [invalid]="isFieldInvalid()"
  />

  @if (props.description) {
    <div class="text-sm text-surface-600 dark:text-surface-400">
      {{ props.description }}
    </div>
  }

  @if (isFieldInvalid()) {
    <small class="text-red-500">{{ getErrorMessage() }}</small>
  }
</div>
